/**
 * Per-route visual tone for EnterpriseShell `data-admin-tone`.
 * Border/elevation/soft fills only — must not change page or surface background
 * (all tabs share the same charcoal canvas).
 */

export type AdminScreenTone =
  | 'overview'
  | 'analytics'
  | 'catalog'
  | 'transactions'
  | 'compliance'
  | 'settings'
  | 'dev'
  | 'default';

export function resolveAdminScreenTone(pathname: string): AdminScreenTone {
  const path = pathname.toLowerCase();
  if (
    path.includes('/analytics') ||
    path.includes('/funnel') ||
    path.includes('/mission-control') ||
    path.includes('/command-center') ||
    path.includes('/tenant-command')
  ) {
    return 'analytics';
  }
  if (
    path.includes('/product') ||
    path.includes('/categor') ||
    path.includes('/catalog') ||
    path.includes('/inventory')
  ) {
    return 'catalog';
  }
  if (path.includes('/transaction') || path.includes('/order') || path.includes('/payment')) {
    return 'transactions';
  }
  if (
    path.includes('/compliance') ||
    path.includes('/consent') ||
    path.includes('/gdpr') ||
    path.includes('/dsr') ||
    path.includes('/audit')
  ) {
    return 'compliance';
  }
  if (
    path.includes('/setting') ||
    path.includes('/account') ||
    path.includes('/profile') ||
    path.includes('/rbac') ||
    path.includes('/user')
  ) {
    return 'settings';
  }
  if (path.includes('/dev') || path.includes('/outbox') || path.includes('/tenant')) {
    return 'dev';
  }
  if (
    path.endsWith('/dashboard') ||
    path.includes('/overview') ||
    path.includes('/home') ||
    /\/t\/[^/]+\/?$/.test(path)
  ) {
    return 'overview';
  }
  return 'default';
}
